// Menu: Quick Search
// 

JLM.MD.MenuSearch = function( container ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Constants: Private _______________________________________________________
	
	// HTML structure
	const TEMPLATE_HTML = '<section class="search"><header><fieldset><div class="textfield"><svg class="icon"><use xlink:href="#jl_icon_search"></use></svg><input type="text" autocorrect="off" autocomplete="off" autocapitalize="on" spellcheck="false" placeholder="Search talent name..."><button type="button" data-action="clear"><svg class="icon"><use xlink:href="#jl_icon_cross"></use></svg></button></div></fieldset></header><div class="results"><div class="frame"><ul></ul></div></div></section>';
	
	// Settings
	const MAX_RESULTS = 10,
	      TIME_SEARCH_PAUSE = 700;
	
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let section, textfield, results_frame, results_list, message;
	
	// Settings
	let search_term = '',
		search_matches = [],
		search_matches_by_id = {},
		timeout_pause;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// References
		let fieldset;
		
		// Create structure
		section = $( TEMPLATE_HTML ).appendTo( container );
		textfield = new JLM.MD.Textfield( $('header fieldset', section) );
		results_frame = $('.frame', section);
		results_list = $('ul', results_frame);
		
		// Events
		results_frame.on('mousewheel', JLM.MT.preventScrollOverflow);
		textfield.on('change', onInputChange);
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Event: Input change
	// 
	function onInputChange() {
		// Update term
		search_term = textfield.value;
		search_term = search_term.replace(/[\\]+/, '/'); // replace backwards slashes
		search_term = search_term.replace(/\(/, '\\('); // replace open bracket
		search_term = search_term.replace(/\)/, '\\)'); // replace close bracket
		
		// Copy current set
		var current_ids = $.extend({}, search_matches_by_id);
		
		// Empty
		results_list.empty();
		search_matches = [];
		search_matches_by_id = {};
		
		// Is filled
		if ( search_term.length ) {
			getMatches( current_ids );
		} else {
			removeMessage();
		}
		
		// Wait for typing pause
		if ( timeout_pause ) clearTimeout( timeout_pause );
		timeout_pause = setTimeout(function() {
			if ( search_term ) {
				JLM.MT.trackEvent('Search', {
					event_category: 'Talent Search',
					event_label: JSON.stringify({
						term: search_term
					})
				});
			}
			timeout_pause = null;
		}, TIME_SEARCH_PAUSE);
	}
	
	
	// Search for talent matches
	// 
	function getMatches( current_ids ) {
		const talent_data = JLM.database.loadTalentList('search', function( talent_data ) {
			let regex = new RegExp("\\b(" + search_term + ')', "i"),
				match_count = 0;
			
			for( let i = 0; i < talent_data.length; i++ ) {
				let name = $.trim( talent_data[i][1] );
				if ( name.match( regex ) ) {
					if ( match_count < MAX_RESULTS ) {
						var talent_id = talent_data[i][0],
							talent_entry_set = ( current_ids[ talent_id ] !== undefined ),
							entry = new JLM.MD.MenuSearchEntry( results_list, talent_data[i], talent_entry_set );
						entry.highlightName( regex );
						search_matches.push( entry );
						search_matches_by_id[ talent_id ] = entry;
					}
					match_count++;
				}
			}
			
			if ( match_count == 0 ) {
				addMessage('No talent matches…');
			} else if ( match_count > search_matches.length ) {
				var remaining = match_count - search_matches.length;
				addMessage('Plus ' + remaining + ' more talent match' + ( remaining == 1 ? '' : 'es' ) + '…');
			} else {
				removeMessage();
			}
		});
	}
	
	
	// Set a message (no results or more results)
	// 
	function addMessage( text_copy ) {
		if ( message ) {
			message.html( text_copy );
		} else {
			message = $('<div class="message">' + text_copy + '</div>').appendTo( results_frame );
		}
	}
	function removeMessage( text_copy ) {
		if ( message ) {
			message.remove();
			message = null;
		}
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Focus on input
	// 
	INSTANCE.focus = function() {
		textfield.focus();
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};